import { Location } from 'history';
import { BFStorage, STORAGE_TOKEN } from '../../../../../libs/core/src/lib/storage';
import { DI_CONTAINER } from '../../../../../libs/core/src';
import { PERSISTED_ROUTE_KEY } from './common';

export async function setPersistedRoute(route: Location): Promise<void> {
  const storage: BFStorage = DI_CONTAINER.get(STORAGE_TOKEN);
  await storage.setItem(PERSISTED_ROUTE_KEY, JSON.stringify(route));
}
